import { render } from "./AccountRegister.vue?vue&type=template&id=376286a2&scoped=true"
import script from "./AccountRegister.vue?vue&type=script&lang=js"
export * from "./AccountRegister.vue?vue&type=script&lang=js"

import "./AccountRegister.vue?vue&type=style&index=0&id=376286a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-376286a2"]])

export default __exports__